import React, { useContext, useEffect, useState } from 'react'
import { ReactComponent as NewProduct } from "../../../images/productsIcons/newProduct.svg";
import DynamicProductIcon from '../../../commonfields/DynamicProductIcon';
import Service from '../../../services';
import { IOrgProductModel } from '../../../models/SharedModel';
import { BankUserContext } from '../../../bankUserContext';
import { catchError } from '../../../utils/Utils';

interface ProductsProps{
  productsHandler:Function;
}

const Products = (props:ProductsProps) => {
  const {productsHandler} = props
  const [orgProductsList, setOrgProductsList] = useState<IOrgProductModel[]>([]);
  const service = new Service()
  const context = useContext(BankUserContext);

  const getOrgProductsByOrgId = () => {
    const payload = {
      screen: "ProspectDetails",
      sections: "getOrgProductsByOrgId",
     orgId: context.bankuserDetails?.organization?.orgId,  
     roleId: context?.bankRolesData?.roleId,
      isJsonReturnObject: false,
    };
    service
      .getOrgProductsByOrgId(payload)
      .then((res) => {
        console.log(res?.data) 
        setOrgProductsList(res?.data);  
       
      })
      .catch((err) => catchError(err, true));
  };

  // const data= [
  //   {
  //     id:0,
  //     name:'Commercial Loans',
  //     image:'Commercial Loan',
  //   },
  //   {
  //     id:1,
  //     name: 'DDA Account',
  //     image:'Commercial DDA',
  //   },
  //   {
  //     id:2,
  //     name:'Payments',
  //     image:"Payments"
  //   },
  //   {
  //     id:3,
  //     name:'New Product',
  //     image:<NewProduct/>
  //   },
  // ]
  useEffect(()=>{
    getOrgProductsByOrgId();
  },[])
  return(
    <div className="productsMain">
      <p className="header">Select a Product:</p>
      <div className="productsList">    
        {orgProductsList.map((m:any)=>
          ( 
            <div key={m.orgLevelProductId} className="productItem" onClick={() => productsHandler()}>
            <DynamicProductIcon  productName = {m.productName} />
            <div>{m.productName}</div>
          </div>
            ))}
      </div>
    </div>
  )
}

export default Products